import * as React from 'react';

import { AppState } from 'common/models/AppState';
import { Chapter } from 'common/api/models/Chapter';
import { FormikProps } from 'formik';
import { PostalApi } from 'common/api/resources/PostalApi';
import { toApiError } from '../../utils/api';
import { FormInput } from 'common/components/form/FormInput';

interface FormChapterIdSelectProps {
  appState: AppState;
  form: FormikProps<any>;
}
export class FormChapterIdSelect extends React.Component<FormChapterIdSelectProps> {
  handleSetChapterId = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const values = this.props.form.values;

    let country = '';
    let postal = '';
    if (values.home_country && values.home_postal) {
      country = values.home_country;
      postal = values.home_postal;
    } else if (values.work_country && values.work_postal) {
      country = values.work_country;
      postal = values.work_postal;
    } else if (values.country && values.postal) {
      country = values.country;
      postal = values.postal;
    }

    postal = postal.trim().substring(0, country === 'US' ? 5 : 3);

    if (country && postal) {
      PostalApi.getPostalByCountryPostal(country, postal).then(
        res => {
          if (res.chapterId) {
            this.props.form.setFieldValue('chapterId', res.chapterId);
          }
        },
        error => {
          console.log(error);
          this.props.form.setFieldError('chapterId', toApiError(error));
        }
      );
    } else {
      this.props.form.setFieldError('chapterId', 'Unable to assign a chapter without both country and postal code.');
    }
  };

  render() {
    let chapters: Chapter[] = [];
    for (let k in this.props.appState.entities.chapter) {
      if (this.props.appState.entities.chapter.hasOwnProperty(k)) {
        chapters.push(this.props.appState.entities.chapter[k]);
      }
    }
    return (
      <FormInput
        id="chapterId"
        label={
          <React.Fragment>
            Membership Chapter{' '}
            <a className="btn btn-secondary btn-sm" onClick={this.handleSetChapterId}>
              Assign from postal code
            </a>
          </React.Fragment>
        }
        tag="select"
        name="chapterId"
        autoComplete="off"
      >
        <option value="">None/Foreign</option>
        {chapters.map(c => (
          <option key={c.id} value={c.id}>
            {c.region}: {c.name}
          </option>
        ))}
      </FormInput>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/form/FormChapterIdSelect.tsx